// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3VVrD","footer":"Form_footer__3EzoY"};